import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import HomeId from '../views/home-id.vue';
import { canonicalLink } from '@/utlis/siteConfig';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const page = (path, name, meta, component) => ({
  path,
  alias: path.endsWith('/') ? path.slice(0, -1) : `${path}/`,
  name,
  meta: { appname: 'GBWhatsApp', ...meta, link: canonicalLink(path) },
  component,
});

export const constRoutesPc = [
  page(
    '/',
    'en-gb',
    {
      title: 'GB WhatsApp APK Latest Version Updated Oct 2026 | GB Wave',
      keywords: 'GB WhatsApp, GB WhatsApp APK, GBWhatsApp download',
      description:
        'Download the latest GB WhatsApp APK updated in Oct 2026. Enjoy enhanced privacy, customizable themes, larger file sharing, auto reply, and more with complete guides on GB Wave.',
    },
    Home,
  ),
  page(
    '/id/',
    'id-gb',
    {
      title: 'Unduh WA GB APK v18.80 Anti-Ban Terbaru 2026 – GB Wave',
      keywords: 'WA GB, WA GB APK, WhatsApp GB',
      description:
        'Unduh WA GB APK terbaru 2026 dengan fitur privasi, tema, dan kustomisasi lengkap. Dapatkan versi terbaru WA GB dengan mudah dan gratis.',
    },
    HomeId,
  ),
  page(
    '/download/',
    'en-download',
    {
      title: 'Download GB WhatsApp v18.80 APK Page – Fast & Free | GB Wave',
      keywords: 'download GB WhatsApp APK, GB WhatsApp download, GBWhatsApp APK',
      description:
        'Explore GB WhatsApp with feature overviews, installation guides, update tutorials, troubleshooting tips, and the latest APK information from GB Wave.',
    },
    () => import('@/views/download.vue'),
  ),
  {
    path: '/download-apk/',
    redirect: '/download/',
  },
  page(
    '/old-versions/',
    'gb-whatsapp-old-version',
    {
      title: 'GB WhatsApp Old Versions Download for Android | GB Wave',
      keywords: 'GB WhatsApp old version, download older GBWhatsApp APK',
      description:
        'Download GB WhatsApp old versions for Android, including v18.70, v18.60, v18.50, and earlier releases. Compare versions, check compatibility, and choose the APK that best fits your device.',
    },
    () => import('@/views/gb-whatsapp-old-version.vue'),
  ),
  {
    path: '/gb-whatsapp-old-version/',
    redirect: '/old-versions/',
  },
  page(
    '/guides/',
    'guides-hub',
    {
      title: 'GB WhatsApp Guides - Backup, Update & Transfer Tips',
      keywords: 'GB WhatsApp guides, backup, update, transfer chats',
      description:
        'Explore GB WhatsApp guides for backup, updates, chat transfer, installation, and feature tutorials. Get practical solutions for common issues.',
    },
    () => import('@/views/guides.vue'),
  ),
  page(
    '/how-to-backup-gb-whatsapp-before-updating/',
    'guide-backup',
    {
      title: 'How to Backup GB WhatsApp Before Updating',
      keywords: 'backup GB WhatsApp, GBWhatsApp backup before update',
      description:
        'Learn how to backup GB WhatsApp chats, photos, videos, and files before updating to a new version without losing your important data.',
    },
    () => import('@/views/guide-backup.vue'),
  ),
  page(
    '/pin-chats-in-gb-whatsapp/',
    'guide-pin-chats',
    {
      title: 'How to Pin Chats in GB WhatsApp',
      keywords: 'pin chats in GB WhatsApp, pin chat, GBWhatsApp pin',
      description:
        'Keep important conversations easy to find with this GB WhatsApp guide to pinning chats, removing pinned conversations, and managing your chat list.',
    },
    () => import('@/views/guide-pin-chats.vue'),
  ),
  page(
    '/download-gb-whatsapp-status-videos/',
    'guide-status-videos',
    {
      title: 'How to Download GB WhatsApp Status Videos',
      keywords: 'download GB WhatsApp status videos, save status, GBWhatsApp status',
      description:
        'Find out how to save GB WhatsApp status videos to your Android phone, check available media options, and locate status files using your file manager.',
    },
    () => import('@/views/guide-status-videos.vue'),
  ),
  page(
    '/how-to-update-gb-whatsapp-without-losing-chats/',
    'guide-update',
    {
      title: 'How to Update GB WhatsApp Without Losing Chats',
      keywords: 'update GB WhatsApp without losing chats',
      description:
        'Update GB WhatsApp safely without losing chats, photos, and media files. Follow these steps to backup data and install the latest version.',
    },
    () => import('@/views/guide-update.vue'),
  ),
  page(
    '/how-to-transfer-gb-whatsapp-to-new-phone/',
    'guide-transfer',
    {
      title: 'How to Transfer GB WhatsApp to a New Phone',
      keywords: 'transfer GB WhatsApp new phone, move GBWhatsApp',
      description:
        'Learn how to transfer GB WhatsApp chats, photos, videos, and files to a new phone with simple backup and restore methods.',
    },
    () => import('@/views/guide-transfer.vue'),
  ),
  page(
    '/troubleshooting/',
    'troubleshooting-hub',
    {
      title: 'All GB WhatsApp Troubleshooting Guides | GB Wave',
      keywords: 'GB WhatsApp troubleshooting, fix GBWhatsApp problems',
      description:
        'Find solutions to common GB WhatsApp problems, including installation errors, verification failures, update issues, notification problems, chat restore, and more.',
    },
    () => import('@/views/troubleshooting.vue'),
  ),
  page(
    '/gb-whatsapp-not-installing/',
    'trouble-install',
    {
      title: 'GB WhatsApp Not Installing? Fix Installation Errors',
      keywords: 'GB WhatsApp not installing, APK not installed',
      description:
        'GB WhatsApp not installing on your Android phone? Check common causes and simple fixes for APK installation errors, storage issues, and compatibility problems.',
    },
    () => import('@/views/trouble-install.vue'),
  ),
  page(
    '/gb-whatsapp-verification-failed/',
    'trouble-verify',
    {
      title: 'GB WhatsApp Verification Failed Fix Guide',
      keywords: 'GB WhatsApp verification failed, OTP not coming',
      description:
        'Facing GB WhatsApp verification failed errors? Learn why OTP verification fails and how to fix SMS, network, and account verification problems.',
    },
    () => import('@/views/trouble-verify.vue'),
  ),
  page(
    '/gb-whatsapp-update-failed/',
    'trouble-update',
    {
      title: 'GB WhatsApp Update Failed? Fix Update Errors',
      keywords: 'GB WhatsApp update failed, cannot update GBWhatsApp',
      description:
        'GB WhatsApp update failed while installing a new version? Learn how to fix APK update errors, compatibility issues, and installation problems.',
    },
    () => import('@/views/trouble-update.vue'),
  ),
  page(
    '/gb-whatsapp-chat-backup-not-working/',
    'trouble-chat-backup-not-working',
    {
      title: 'GB WhatsApp Chat Backup Not Working? Easy Fixes',
      keywords: 'GB WhatsApp chat backup not working, GBWhatsApp backup stuck',
      description:
        'GB WhatsApp chat backup not working or getting stuck? Try these simple fixes for backup errors, missing files, and failed backups.',
    },
    () => import('@/views/trouble-chat-backup-not-working.vue'),
  ),
  page(
    '/gb-whatsapp-chats-not-restoring/',
    'trouble-chats-not-restoring',
    {
      title: 'GB WhatsApp Chats Not Restoring After Reinstall? Easy Fixes',
      keywords: 'GB WhatsApp chats not restoring, GBWhatsApp restore backup',
      description:
        'GB WhatsApp chats not restoring after reinstalling? Check backup files, storage, permissions, folder locations, and version compatibility.',
    },
    () => import('@/views/trouble-chats-not-restoring.vue'),
  ),
  page(
    '/gb-whatsapp-notifications-not-working/',
    'trouble-notifications-not-working',
    {
      title: 'GB WhatsApp Notifications Not Working? Easy Fixes',
      keywords: 'GB WhatsApp notifications not working, GBWhatsApp delayed notifications',
      description:
        'GB WhatsApp notifications not working or delayed? Check notification permissions, battery settings, background data, and other easy fixes.',
    },
    () => import('@/views/trouble-notifications-not-working.vue'),
  ),
  page(
    '/gb-whatsapp-sms-code-not-received/',
    'trouble-sms-code-not-received',
    {
      title: 'Why Is GB WhatsApp Not Sending the SMS Code?',
      keywords: 'GB WhatsApp SMS code not received, GBWhatsApp verification code',
      description:
        'Why is your GB WhatsApp SMS code not arriving? Check your phone number, mobile signal, carrier settings, and verification timer to troubleshoot the issue.',
    },
    () => import('@/views/trouble-sms-code-not-received.vue'),
  ),
  page(
    '/gb-whatsapp-keeps-crashing/',
    'trouble-keeps-crashing',
    {
      title: 'Why Does GB WhatsApp Keep Crashing on Android?',
      keywords: 'GB WhatsApp keeps crashing, GBWhatsApp app crashes Android',
      description:
        'Why does GB WhatsApp keep crashing or freezing? Check storage, clear temporary cache files, review Android compatibility, and protect your chats before reinstalling.',
    },
    () => import('@/views/trouble-keeps-crashing.vue'),
  ),
  page(
    '/is-gb-whatsapp-safe/',
    'trouble-is-gb-whatsapp-safe',
    {
      title: 'Is GB WhatsApp Safe? Security and Privacy Risks',
      keywords: 'is GB WhatsApp safe, GBWhatsApp APK security, GB WhatsApp privacy',
      description:
        'Is GB WhatsApp safe to use? Review APK security, privacy concerns, account restrictions, and chat backup risks before installing a modified app.',
    },
    () => import('@/views/trouble-is-gb-whatsapp-safe.vue'),
  ),
  page(
    '/avoid-gb-whatsapp-account-restrictions/',
    'trouble-avoid-account-restrictions',
    {
      title: 'How Can You Avoid GB WhatsApp Account Restrictions?',
      keywords: 'avoid GB WhatsApp account restrictions, WhatsApp ban, GBWhatsApp restriction',
      description:
        'How can you reduce WhatsApp account restriction risks? Understand unofficial app risks, avoid spam, protect your chats, and follow official support instructions.',
    },
    () => import('@/views/trouble-avoid-account-restrictions.vue'),
  ),
  page(
    '/about-us/',
    'about-us',
    {
      title: 'About Us | GBWave',
      keywords: 'About GB Wave',
      description:
        'Learn about GB Wave, a website providing GB WhatsApp APK updates, features, installation guides, and troubleshooting tips.',
    },
    () => import('@/views/about.vue'),
  ),
  page(
    '/contact-us/',
    'contact-us',
    {
      title: 'Contact Team | GB Wave',
      keywords: 'Contact GB Wave',
      description:
        'Contact GB Wave for questions, feedback, copyright concerns, or website-related inquiries.',
    },
    () => import('@/views/contact.vue'),
  ),
  page(
    '/privacy-policy/',
    'privacy-policy',
    {
      title: 'Privacy Policy - GB Wave',
      keywords: 'GB Wave privacy policy',
      description:
        'Read GB Wave Privacy Policy to understand how we collect, use, and protect your information.',
    },
    () => import('@/views/privacy.vue'),
  ),
  page(
    '/terms-of-use/',
    'terms-of-use',
    {
      title: 'Terms of Use - GB Wave',
      keywords: 'GB Wave terms of use',
      description:
        'Read GB Wave Terms of Use to understand website rules, content usage, and user responsibilities.',
    },
    () => import('@/views/terms.vue'),
  ),
  page(
    '/disclaimer/',
    'disclaimer',
    {
      title: 'Disclaimer - GB Wave',
      keywords: 'GB Wave disclaimer',
      description:
        'Read GB Wave Disclaimer about third-party applications, website information, and user responsibilities.',
    },
    () => import('@/views/disclaimer.vue'),
  ),
  page(
    '/dmca/',
    'dmca-policy',
    {
      title: 'DMCA Policy - GB Wave',
      keywords: 'GB Wave DMCA',
      description:
        'Learn about GB Wave DMCA policy and submit copyright removal requests.',
    },
    () => import('@/views/dmca.vue'),
  ),
  {
    path: '/dmca-policy/',
    redirect: '/dmca/',
  },
];

export default function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      return { x: 0, y: 0 };
    },
  });

  // Vue Router 3 常把尾斜杠吃掉；用 replaceState 只改地址栏，避免再次导航死循环
  router.afterEach(() => {
    if (typeof window === 'undefined') return;
    const { pathname, search, hash } = window.location;
    if (
      pathname.length > 1 &&
      !pathname.endsWith('/') &&
      !/\.[a-zA-Z0-9]+$/.test(pathname)
    ) {
      window.history.replaceState(
        window.history.state,
        '',
        `${pathname}/${search}${hash}`,
      );
    }
  });

  return router;
}
